let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iQGmY")).then(() => parcelRequire('esCFD'));